module.exports = __webpack_public_path__ + "static/media/bird_sitting_page11.bf685b46.png";